import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { useTranslation } from 'react-i18next';

import { useEmspBoInvoiceContext } from '../emsp-bo-invoice.context';

export const EmspBoInvoiceTotalsDetailsController = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const invoice = useEmspBoInvoiceContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card flex={1} gap={GapEnum.M}>
      <AccentTitle
        icon="currency-euro-circle"
        as={HeadingEnum.H2}
        text={t('$.emsp-bo-invoice-details.totals.title')}
      />
      <Stack justifyContent="space-between">
        <Text bold>{t('delmonicos-shared-sdk.outputs-invoice.total-ht')}</Text>
        <Text>{toCurrencyString(invoice.totalHT, invoice.currency)}</Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>{t('delmonicos-shared-sdk.outputs-invoice.total-vat')}</Text>
        <Text>{toCurrencyString(invoice.totalVat, invoice.currency)}</Text>
      </Stack>
      <Stack justifyContent="space-between">
        <Text bold>{t('delmonicos-shared-sdk.outputs-invoice.total-ttc')}</Text>
        <Text>{toCurrencyString(invoice.totalTTC, invoice.currency)}</Text>
      </Stack>
    </Card>
  );
};
